import {
  basicInfoSchema,
  childInfoSchema,
  earlySignsSchema,
  preventionPlanSchema,
  ratingsSchema,
  roadmapSchema,
  sensitivitiesSchema,
  whatHelpsSchema,
} from "@/lib/sensory-profile/schema";

export const SENSORY_PROFILE_STEPS = [
  {
    id: "roadmap",
    title: "Regulation Roadmap",
    description: "Green, yellow, and red — a shared language for support.",
    schema: roadmapSchema,
    fields: [] as const,
  },
  {
    id: "basic",
    title: "Basic Information",
    description:
      "Your name, contact details, date of birth, and privacy policy.",
    schema: basicInfoSchema,
    fields: [
      "firstName",
      "lastName",
      "dateOfBirth",
      "email",
      "phone",
      "privacyAgreed",
    ] as const,
  },
  {
    id: "child",
    title: "Child Information",
    description: "Child's name or nickname and date of birth.",
    schema: childInfoSchema,
    fields: ["childNickname", "childDateOfBirth"] as const,
  },
  {
    id: "sensitivities",
    title: "Sensory Sensitivities",
    description: "What tends to overwhelm your child? Select all that apply.",
    schema: sensitivitiesSchema,
    fields: [
      "selectedSounds",
      "additionalSounds",
      "selectedLightsAndVisualInput",
      "additionalLightsAndVisualInput",
      "selectedTouchAndTextures",
      "additionalTouchAndTextures",
      "selectedSmells",
      "additionalSmells",
      "selectedTastes",
      "additionalTastes",
      "selectedMovement",
      "additionalMovement",
      "selectedBodyAwareness",
      "additionalBodyAwareness",
      "selectedEnvironmental",
      "additionalEnvironmental",
    ] as const,
  },
  {
    id: "ratings",
    title: "Sensitivity Rating",
    description:
      "How strongly does this affect your child? 0 is not a problem, 1–3 mild, 4–6 moderate, 7–10 severe.",
    schema: ratingsSchema,
    fields: ["sensitivityRatings"] as const,
  },
  {
    id: "early-signs",
    title: "Early Signs of Overload",
    description: "How do I know my child is becoming overwhelmed?",
    schema: earlySignsSchema,
    fields: ["selectedEarlySigns", "additionalEarlySigns"] as const,
  },
  {
    id: "what-helps",
    title: "What Helps?",
    description: "What can I change to help?",
    schema: whatHelpsSchema,
    fields: ["selectedWhatHelps", "additionalWhatHelps"] as const,
  },
  {
    id: "prevention-plan",
    title: "My Meltdown Prevention Plan",
    description:
      "Top triggers, earliest signs, and what to do if overload starts.",
    schema: preventionPlanSchema,
    fields: [
      "triggerOne",
      "triggerTwo",
      "triggerThree",
      "earliestSigns",
      "whatUsuallyHelps",
      "overloadPlan",
    ] as const,
  },
] as const;
